import fontawesome from '@fortawesome/fontawesome';
import faSolid from '@fortawesome/fontawesome-free-solid';
import moment from 'moment';
import Raven from 'raven-js';
import $ from 'jquery';
import 'bootstrap';

import renderFormControls from './components/FormControl';
import renderProductForm from './components/ProductForm';
import initProductionView from "./views/ProductionView";
import initOrderList from "./views/OrderList";
import initOrdersUpdateButton from "./views/OrdersUpdateButton";
import initReports from "./views/Reports";


// Install Raven in production envs
if (process.env.NODE_ENV === 'production') {
    Raven.config(DJ_CONST.RAVEN_PUBLIC_DSN).install(); // eslint-disable-line
    // handle rejected promises
    window.addEventListener('unhandledrejection', (evt) => {
        Raven.captureException(evt.reason);
    });
    // If we have authenticated user, pass its data on to Raven
    if (DJ_CONST.user) {
        Raven.setUserContext({
            id: DJ_CONST.user.id,
            email: DJ_CONST.user.email,
            name: DJ_CONST.user.name,
        });
    }
}


function init() {
    renderFormControls();

    // init bootstrap components
    $(() => $('[data-toggle="tooltip"]').tooltip({boundary: 'window'}));
}

function initProductForm(containerId, productId, orderId, orderRowNr, welderRole, initial, operationOptions) {
    renderProductForm(containerId, productId, orderId, orderRowNr, welderRole, initial, operationOptions);
}

// Add the needed Font Awesome icons
fontawesome.library.add(faSolid.faCheck, faSolid.faSpinner, faSolid.faTimes, faSolid.faUserPlus, faSolid.faFileExcel);

// Set moment locale
moment.locale('et');


export {init, initOrderList, initOrdersUpdateButton, initProductionView, initProductForm, initReports};



// WEBPACK FOOTER //
// ./src/main.js